<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"><span class="sz"> </span></p>
<p class="p6"><span class="sz"><i>For my parents, for enabling me to write</i></span></p>
<p class="p6"><span class="sz"><i>unfettered by the bonds of nonexistence.</i></span></p>
<p class="p5"><span class="sz"><i></i> </span></p>
<p class="p6"><span class="sz"><i>For Robin, Harlan, Kate and Damon,</i></span></p>
<p class="p6"><span class="sz"><i>for the same.</i></span></p>
<p class="p5"><span class="sz"><i></i> </span></p>
<p class="p6"><span class="sz"><i>And always, especially, for Dia.</i></span></p>
<p class="p8"><span class="sz"><i></i> </span></p>
<p class="p8"><span class="sz"><i></i> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?73f3d7bf